export const CONTACT_ADDRESS_LINE_1 = '130 W 37 St, Ground Floor';
export const CONTACT_ADDRESS_LINE_2 = 'New York, NY 10018';

export const CONTACT_ADDRESS = `${CONTACT_ADDRESS_LINE_1}, ${CONTACT_ADDRESS_LINE_2}`;

export const CONTACT_PHONE = '12124016011';
export const CONTACT_PHONE_FORMATTED = '1-212-401-6011';
export const CONTACT_EMAIL = 'admin@violerts.com';

